import React from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { Badges, H3, H5, Image, LI, ProgressBar, UL } from '../../../../AbstractElements'
import SvgIcon from '../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { dynamicImage, dynamicNumber } from '../../../../Utils'

export default function FeedbackCard() {
    return (
        <Col xl={3} sm={6}>
            <Card className="progress-items">
                <CardHeader className="pb-0">
                    <div className="d-flex justify-content-between">
                        <div>
                            <div className="d-flex gap-2">
                                <H5>Feedback</H5>
                                <Badges color='' className="badge align-items-center d-flex badge-light-success">
                                    <SvgIcon className='feather me-1 pt-0' iconId='arrow-chart-up' />
                                    <span>+2.4%</span>
                                </Badges>
                            </div>
                            <H3 className="mt-3">{'75,565'}</H3>
                        </div>
                        <div className="flex-shrink-0 bg-light-success">
                            <SvgIcon className='svg-w-23 fill-success' iconId='feedback' />
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="progress-card align-items-center pt-0">
                    <div className="user-details customers">
                        <UL className='simple-list flex-row'>
                            <LI className="d-inline-block">
                                {dynamicNumber(4).map((item, index) => (
                                    <Image className="rounded-circle" key={index} src={dynamicImage(`dashboard-2/user/${item}.png`)} alt="user" />
                                ))}
                            </LI>
                        </UL>
                    </div>
                    <ProgressBar color='success' value={50} />
                </CardBody>
            </Card>
        </Col>
    )
}